

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ceaPatientRegisterParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface ceaPatientRegister {

  fromDate: any;
  toDate: string;
 
  physicianId: any;
   
  skip:Number,
  take:Number,
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: ceaPatientRegisterParameter[];
    links?: any;
}

export abstract class ceaPatientRegisterData {


  abstract search(url: string,data:any): Observable<any>;
}
